import { makeStyles } from "@material-ui/core";

export const paymentPlansModalStyle = makeStyles((theme) => ({
  paymentModal: {
    "& .MuiDialog-paper": {
      margin: "12px",
    },
    "& .MuiDialog-paperWidthSm": {
      backgroundColor: "#ECF3F8",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "550px",
      },
      [theme.breakpoints.up("sm")]: {
        maxWidth: "750px",
      },
    },
    "& .MuiIconButton-label": {
      color: "#000000",
      "& svg.MuiSvgIcon-root": {
        fontSize: "2rem",
      },
    },
  },
  dialogContent: {
    paddingTop: "0px",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "7px 0px 0px 0px",
    height: "25px",
    "& button": {
      height: "20px",
    },
  },
  planBenefitContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  planBenefit: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    color: "#0F172A",
    fontFamily: "Inter",
    fontWeight: "600",
    marginBottom: theme.spacing(1),
    fontSize: theme.typography.pxToRem(18),
    [theme.breakpoints.only("sm")]: {
      fontSize: theme.typography.pxToRem(20),
    },
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(28),
    },
  },
  subtitle: {
    color: "#0F172A",
    fontSize: "16px",
  },
  contactSupport: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.only("xs")]: {
      flexDirection: "column",
    },
    marginTop: "20px",
    marginBottom: "20px",
    "& > *:first-child": {
      color: "#000000",
      fontFamily: "Lato",
      fontWeight: "400",
      marginBottom: "3px",
      [theme.breakpoints.only("xs")]: {
        fontSize: theme.typography.pxToRem(18),
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    "& a": {
      color: "#0344DC",
      marginLeft: "5px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Inter",
      fontWeight: "600",
      [theme.breakpoints.only("xs")]: {
        marginTop: "24px",
        marginLeft: "0px",
        fontSize: theme.typography.pxToRem(20),
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
  },
}));
